var _g, _g2, _text, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnboardingCheckout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 312,
    height: 47.476
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .168)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 312,
    height: 40,
    rx: 5,
    transform: "translate(0 -.168)",
    fill: "#ffce2b"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(156 25.832)",
    fill: "#323232",
    fontSize: 14,
    fontFamily: "Lato-Semibold, Lato",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -29.603,
    y: 0
  }, "Checkout")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#969696"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.707 21.886a.75.75 0 01-.75-.75v-8.25a.75.75 0 01.75-.75.75.75 0 01.75.75v8.249a.75.75 0 01-.75.751zM208.612 22.715a.75.75 0 01-.65-.375l-4.125-7.144a.75.75 0 01.275-1.025.75.75 0 011.025.275l4.124 7.144a.75.75 0 01-.649 1.125zM206.345 24.981a.747.747 0 01-.374-.1l-7.144-4.125a.75.75 0 01-.275-1.025.75.75 0 011.025-.275l7.144 4.125a.75.75 0 01-.376 1.4zM205.516 28.076h-8.249a.75.75 0 01-.75-.75.75.75 0 01.75-.75h8.249a.75.75 0 01.751.75.75.75 0 01-.751.75zM226.147 28.076h-8.249a.75.75 0 01-.75-.75.75.75 0 01.75-.75h8.249a.75.75 0 01.751.75.75.75 0 01-.751.75zM199.202 35.297a.75.75 0 01-.65-.375.75.75 0 01.275-1.025l7.144-4.125a.75.75 0 011.025.275.75.75 0 01-.275 1.025l-7.144 4.124a.747.747 0 01-.375.101zM217.069 24.981a.75.75 0 01-.65-.375.75.75 0 01.275-1.025l7.144-4.125a.75.75 0 011.025.275.75.75 0 01-.275 1.025l-7.144 4.124a.747.747 0 01-.375.101zM214.803 22.715a.747.747 0 01-.374-.1.75.75 0 01-.276-1.025l4.125-7.144a.75.75 0 011.025-.275.75.75 0 01.274 1.025l-4.124 7.144a.75.75 0 01-.65.375z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(210.913 44.476)",
    fill: "#f8f8f8",
    fontSize: 20,
    fontFamily: "FontAwesome5Free-Solid, 'Font Awesome \\\\\\\\35 Free'"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uF245"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M218.195 47.476a1.2 1.2 0 01-1.1-.741v-.006l-1.782-4.339-2.859 2.936a1.167 1.167 0 01-.84.363 1.209 1.209 0 01-1.201-1.213V27.691a1.213 1.213 0 011.209-1.215 1.124 1.124 0 01.839.37l11.1 11.417a1.2 1.2 0 01.26 1.311 1.2 1.2 0 01-1.1.758h-3.4l1.892 4.623a1.218 1.218 0 01-.626 1.583h-.005l-1.917.838a1.167 1.167 0 01-.47.1zm-.182-1.13a.192.192 0 00.25.115l1.917-.835a.226.226 0 00.11-.29l-2.464-6h4.887a.2.2 0 00.177-.135.2.2 0 00-.038-.223l-.01-.01-11.118-11.445a.128.128 0 00-.102-.047.211.211 0 00-.209.215v16.785a.211.211 0 00.2.213.171.171 0 00.124-.06l3.917-4.029z",
    fill: "#323232"
  })));
}
export default SvgOnboardingCheckout;